import React, { useEffect, useState } from 'react'
import {
  CardActionArea,
  Card,
  Box,
  Typography,
  IconButton,
  Divider
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowForwardIos } from '@material-ui/icons/'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'

import { getOdsData } from '../../../utils/configQueries'

import { IconMap } from '../../../utils/icons'
import { t } from '../../../utils/languages'

import { useGlobalContext, sideBarRightVisibilityChanged } from '../../../state'

export const FeaturesTable = () => {
  const {
    state: {
      sideBarRight: { featuresDataTable },
      genericLayer: { priority, country, projectType, name, icon, color }
    }
  } = useGlobalContext()

  const [details, setDetails] = useState(null)
  const { dispatch } = useGlobalContext()
  const useStyles = makeStyles((theme) => ({
    container: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    detailsContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      marginBottom: theme.spacing(3)
    },
    title: {
      marginBottom: theme.spacing(1)
    },
    boxIcon: {
      display: 'grid',
      gridTemplateColumns: '25% 25% 25% 25%',
      alignSelf: 'center',
      marginTop: theme.spacing(2)
    },
    accordionContainer: {
      border: '2px solid white',
      color: '#65848b',
      background: '#dee8e8',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    containerTitle: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      alignItems: 'center'
    },
    boxIconOption: {
      display: 'grid',
      gridTemplateColumns: '1fr 3fr',
      backgroundColor: '#dee8e8',
      borderRight: '2px solid white',
      padding: theme.spacing(1),
      alignItems: 'center'
    },
    ods: {
      width: '8%',
      margin: '5px',
      opacity: '30%'
    },
    odsInclude: {
      width: '8%',
      margin: '5px',
      opacity: '30%',
      opacity: '100% !important'
    },
    divider: {
      height: 2,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      backgroundColor: '#65848b'
    },
    backBtn: {
      display: 'grid',
      gridTemplateColumns: '3fr 1fr',
      marginBottom: theme.spacing(2)
    },
    optionIcon: {
      width: theme.spacing(4),
      height: theme.spacing(4)
    }
  }))
  const classes = useStyles()

  const odsData = getOdsData()

  const PDIprojects = featuresDataTable.filter(({ custom_fields }) =>
    custom_fields.some(({ id, value }) => id === 43 && value === '1')
  )
  const otherProjects = featuresDataTable.filter(({ custom_fields }) =>
    custom_fields.some(({ id, value }) => id === 43 && value !== '1')
  )
  const nacionales = featuresDataTable.filter(({ custom_fields }) =>
    custom_fields.some(({ id, value }) => id === 13 && value === 'Nacional')
  )
  const supranacionales = featuresDataTable.filter(({ custom_fields }) =>
    custom_fields.some(
      ({ id, value }) => id === 13 && value === 'Supranacional'
    )
  )
  const subnacionales = featuresDataTable.filter(({ custom_fields }) =>
    custom_fields.some(({ id, value }) => id === 13 && value === 'Subnacional')
  )

  useEffect(() => {
    setDetails(null)
  }, [featuresDataTable, priority, country, projectType, name])

  return (
    <Box>
      <Box>
        <Typography variant="h5">
          {t('LISTADO DE PROYECTOS SUB:REGIÓN PDI')}
        </Typography>
        <Box className={classes.boxIcon}>
          {(country === 'pdi' || country === 'mex') && IconMap.get('México')}
          {(country === 'pdi' || country === 'gtm') && IconMap.get('Guatemala')}
          {(country === 'pdi' || country === 'hnd') && IconMap.get('Honduras')}
          {(country === 'pdi' || country === 'slv') &&
            IconMap.get('El Salvador')}
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.backBtn}>
          <Box>
            <Typography variant="subtitle1" className={classes.title}>
              {t(name)}
            </Typography>
            <Typography variant="subtitle1" className={classes.title}>
              {t('Proyectos seleccionados')}
            </Typography>
          </Box>
          <IconButton
            onClick={() =>
              dispatch(
                sideBarRightVisibilityChanged({
                  selectedType: 'dataTable'
                })
              )
            }
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
        <Box>
          <>
            {!details ? (
              <>
                <Box className={classes.detailsContainer}>
                  <Box>
                    <Typography variant="subtitle2">
                      {t('Cantidad de proyectos')}: {featuresDataTable.length}
                    </Typography>
                    <Typography variant="subtitle2">
                      {t('Proyectos PDI')}: {PDIprojects.length}
                    </Typography>
                    <Typography variant="subtitle2">
                      {t('Otros proyectos')}: {otherProjects.length}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2">
                      {t('Proyectos regionales')}: {supranacionales.length}
                    </Typography>
                    <Typography variant="subtitle2">
                      {t('Proyectos nacionales')}: {nacionales.length}
                    </Typography>
                    <Typography variant="subtitle2">
                      {t('Proyectos subnacionales')}: {subnacionales.length}
                    </Typography>
                  </Box>
                </Box>
                {featuresDataTable.map(({ id, custom_fields }) => {
                  return (
                    <CardActionArea
                      onClick={() => setDetails({ id })}
                      className={classes.accordionContainer}
                      key={id}
                    >
                      <Typography variant="h5">
                        {/* Nombre */}
                        {custom_fields.filter(({ id }) => id === 1)[0].value}
                      </Typography>
                    </CardActionArea>
                  )
                })}
              </>
            ) : (
              <>
                {featuresDataTable
                  .filter(({ id }) => id === details.id)
                  .map(({ custom_fields }) => (
                    <Card
                      key={details.id}
                      style={{
                        border: '2px solid white',
                        padding: 8,
                        marginTop: 16
                      }}
                    >
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '4fr 1fr'
                        }}
                      >
                        <Box>
                          <Typography variant="h5" className={classes.title}>
                            {t('PROYECTO')}:{' '}
                            {
                              custom_fields.filter(({ id }) => id === 1)[0]
                                .value
                            }
                          </Typography>
                          {/* Moneda */} {/* Valor */}
                          <Typography variant="h5">
                            {
                              custom_fields.filter(({ id }) => id === 8)[0]
                                .value
                            }{' '}
                            {
                              custom_fields.filter(({ id }) => id === 7)[0]
                                .value
                            }
                          </Typography>
                        </Box>
                        <IconButton onClick={() => setDetails(null)}>
                          <ArrowForwardIos />
                        </IconButton>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr',
                          alignItems: 'center'
                        }}
                      >
                        <Box>
                          <Typography variant="h5">
                            {t('DIMENSIONES Y PROGRAMAS DEL PDI')}:
                          </Typography>
                        </Box>
                        <Box className={classes.containerTitle}>
                          <Box className={classes.boxIconOption}>
                            <Box>
                              {icon && (
                                <FiberManualRecordIcon
                                  className={classes.optionIcon}
                                  style={{ color: color }}
                                />
                              )}
                            </Box>
                            <Typography variant="h6">
                              {name.slice(0, 5) === 'Pilar'
                                ? t(name).slice(5)
                                : t(name)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr'
                        }}
                      >
                        <Box>
                          <Typography variant="h5">{t('OBJETIVO')}:</Typography>
                        </Box>
                        <Box>
                          <Typography variant="h6">
                            {
                              custom_fields.filter(({ id }) => id === 2)[0]
                                .value
                            }
                          </Typography>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('PRIORIDAD')}:
                          </Typography>
                        </Box>
                        <Box>
                          {/* Alcance */}
                          <Typography variant="h6">
                            {custom_fields.filter(({ id }) => id === 45)[0]
                              .value === '1'
                              ? 'SI'
                              : 'NO'}
                          </Typography>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('NIVEL TERRITORIAL')}:
                          </Typography>
                        </Box>
                        <Box>
                          {/* Alcance */}
                          <Typography variant="h6">
                            {
                              custom_fields.filter(({ id }) => id === 13)[0]
                                .value
                            }
                          </Typography>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('AGENCIA LÍDER')}:
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="h6">
                            {custom_fields
                              .filter(({ id }) => id === 3)[0]
                              .value?.join(', ')}
                          </Typography>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('OTRAS AGENCIAS')}:
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="h6">
                            {
                              custom_fields.filter(({ id }) => id === 4)[0]
                                .value
                            }
                          </Typography>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('SOCIOS IMPLEMENTADORES')}:
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="h6">
                            {
                              custom_fields.filter(({ id }) => id === 5)[0]
                                .value
                            }
                          </Typography>
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '3fr 5fr'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('OBJETIVOS DE DESARROLLO SOSTENIBLE')}:
                          </Typography>
                        </Box>
                        <Box>
                          {odsData &&
                            odsData.map(({ icon, id: idOds }) => (
                              <img
                                key={idOds}
                                className={
                                  // Check ODS Include
                                  custom_fields
                                    .filter(({ id }) => id === 10)[0]
                                    .value.includes(idOds)
                                    ? classes.odsInclude
                                    : classes.ods
                                }
                                src={`images/Iconos/${icon}`}
                                alt={icon}
                              />
                            ))}
                        </Box>
                      </Box>
                      <Divider className={classes.divider} />
                      <Box
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 2fr',
                          alignItems: 'center'
                        }}
                      >
                        {' '}
                        <Box>
                          <Typography variant="h5">
                            {t('TIEMPO DE IMPLEMENTACIÓN')}:
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="h6">
                            {custom_fields
                              .filter(({ id }) => id === 12)[0]
                              .value.slice(0, 4)
                              ? `${
                                  custom_fields
                                    .filter(({ id }) => id === 12)[0]
                                    .value.slice(0, 4) -
                                  custom_fields
                                    .filter(({ id }) => id === 11)[0]
                                    .value.slice(0, 4)
                                }  AÑOS`
                              : t('Sin fecha de término')}
                          </Typography>
                        </Box>
                      </Box>
                    </Card>
                  ))}
              </>
            )}
          </>
        </Box>
      </Box>
    </Box>
  )
}
